import React, { FC } from 'react';
import { ControlObject, RepoNode } from '../../onboarding-types';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import RepoSelectionRow from './RepoSelectionRow';
import { createFlattenList } from '../../onboarding-utils';

const RepoSelectionTree: FC<
  React.PropsWithChildren<RepoSelectionTreeProps>
> = ({ treeData, controlObject }) => {
  const flattenList = createFlattenList(treeData, controlObject, []);
  return (
    <AutoSizer>
      {({ height, width }) => (
        <FixedSizeList
          height={height}
          itemCount={flattenList.length}
          itemSize={30}
          width={width}>
          {({ index, style }) => {
            return (
              <div style={style}>
                <RepoSelectionRow {...flattenList[index]} />
              </div>
            );
          }}
        </FixedSizeList>
      )}
    </AutoSizer>
  );
};

export interface RepoSelectionTreeProps {
  treeData: RepoNode[];
  controlObject: ControlObject;
}

export default RepoSelectionTree;
